import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Header from "./Components/Header/Header";
import axios from "axios";
// import "./App.css";
import "./assets/styles/CreateEvent.css";
import { QRCodeCanvas } from "qrcode.react";

import { API_CREATE_EVENT_URL, API_GET_EVENT_LIST } from "./endpoints";
import DesignGenerator from "./Components/DesignGenerator/DesignGenerator";

const SECRET_KEY = process.env.REACT_APP_ADMIN_SECRET; // Set in Vercel env vars

const CreateEvent = () => {
  const [eventId, setEventId] = useState("");
  const [coverImageUrl, setCoverImageUrl] = useState("");
  const [coverImageFile, setCoverImageFile] = useState(null); // For file upload
  const [customMessage, setCustomMessage] = useState("");
  const [albumOf, setAlbumOf] = useState("");
  const [albumCreatedBy, setAlbumCreatedBy] = useState(""); // New state for Albumcreatedby

  const [secret, setSecret] = useState(""); // State for secret input
  const [isCreating, setIsCreating] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [successMessageFileUpload, setSuccessMessageFileUpload] = useState("");
  const [errorMessageFileUpload, setErrorMessageFileUpload] = useState("");

  const [eventUrl, setEventUrl] = useState(""); // State to store the event URL
  const [eventDate, setEventDate] = useState(""); // State to store the event URL
  const [createdEventData, setCreatedEventData] = useState(null); // For design generator

  const qrCodeRef = useRef(null); // Ref for the QR code

  const [hasVideo, setHasVideo] = useState(false); // New state for hasVideo
  const [hasGuestBook, setHasGuestBook] = useState(false); // New state for hasVideo
  const [isSecondaryTheme, setIsSecondaryTheme] = useState(false); // New state for theme
  const [albumPin, setAlbumPin] = useState("");
  const [eventType, setEventType] = useState("wedding");
  const [hasPhotographer, setHasPhotographer] = useState(false); // "wedding" | "xv" | "corporate" | "party" // Optional PIN for private albums
  const [uploadedImageUrl, setUploadedImageUrl] = useState(""); // To store the uploaded image URL

  const [qrCodeFile, setQrCodeFile] = useState(null);
  const [uploadedQRCodeUrl, setUploadedQRCodeUrl] = useState(""); // Added state for uploaded QR code URL

  // const downloadQRCode = () => {
  //   const qrCanvas = document.querySelector('canvas'); // Select the QR code canvas element

  //   if (qrCanvas) {
  //     const image = qrCanvas.toDataURL('image/png'); // Convert canvas to PNG
  //     const link = document.createElement('a'); // Create an anchor element
  //     link.href = image; // Set the image as the href
  //     link.download = 'qr-code.png'; // Set the download attribute
  //     link.click(); // Programmatically click the link to trigger the download
  //   } else {
  //     console.error('QR code canvas not found!');
  //   }
  // };
  const hiddenCanvasRef = useRef(null); // For the hidden QR code canvas

  const downloadQRCode = () => {
    const qrCanvas = hiddenCanvasRef.current.querySelector("canvas");
    if (qrCanvas) {
      const url = qrCanvas.toDataURL("image/png");
      const eventId = eventUrl.split("eventId=")[1] || "QR_Code";
      const link = document.createElement("a");
      link.href = url;
      link.download = `${eventId}.png`;
      link.click();
    } else {
      console.error("QR code canvas not found!");
    }
  };

  const handleQRCodeUpload = async (event) => {
    event.preventDefault();
    setErrorMessageFileUpload("");
    setSuccessMessageFileUpload("");

    if (!qrCodeFile) {
      setErrorMessageFileUpload("Por favor, selecciona un archivo para subir.");
      return;
    }

    try {
      const response = await axios.post(
        "https://us-central1-moonlit-sphinx-400613.cloudfunctions.net/add-qr-code-to-storage",
        {
          filename: qrCodeFile.name,
          contentType: qrCodeFile.type,
        }
      );

      if (response.status !== 200) {
        throw new Error("Failed to get signed URL");
      }

      const { uploadUrl, publicUrl } = response.data;

      console.log("Received upload URL:", uploadUrl);
      console.log("Public URL:", publicUrl);

      const uploadResponse = await axios.put(uploadUrl, qrCodeFile, {
        headers: {
          "Content-Type": qrCodeFile.type,
        },
      });

      if (uploadResponse.status === 200) {
        console.log("QR Code uploaded successfully!");

        setUploadedQRCodeUrl(publicUrl); // Set the uploaded QR code URL here
        setSuccessMessageFileUpload("El código QR se subió correctamente.");
        setQrCodeFile(null);
      } else {
        throw new Error("Failed to upload QR code to Cloud Storage");
      }
    } catch (error) {
      console.error("Error uploading QR code:", error);
      setErrorMessageFileUpload("Error al subir el código QR.");
    }
  };

  const handleCreateEvent = async (event) => {
    event.preventDefault();
    setIsCreating(true);
    setErrorMessage("");
    setSuccessMessage("");

    // Check if the entered secret is correct
    if (secret !== SECRET_KEY) {
      setErrorMessage("Invalid secret key.");
      setIsCreating(false);
      return;
    }
    // Function to download the QR code as an image

    try {
      // Upload cover image file if selected
      let finalCoverImageUrl = coverImageUrl;
      if (coverImageFile) {
        try {
          const uploadRes = await axios.post(
            "https://us-central1-moonlit-sphinx-400613.cloudfunctions.net/add-qr-code-to-storage",
            {
              filename: `cover_${eventId}_${coverImageFile.name}`,
              contentType: coverImageFile.type,
            }
          );
          const { uploadUrl, publicUrl } = uploadRes.data;
          await axios.put(uploadUrl, coverImageFile, {
            headers: { "Content-Type": coverImageFile.type },
          });
          finalCoverImageUrl = publicUrl;
        } catch (uploadError) {
          console.error("Error uploading cover image:", uploadError);
          setErrorMessage("Error al subir la imagen de portada.");
          return;
        }
      }

      // Create JSON payload
      const payload = {
        eventId,
        coverImageUrl: finalCoverImageUrl,
        customMessage,
        albumOf,
        albumCreatedBy,
        eventDate,
        hasVideo,
        hasGuestBook,
        hasPhotographer,
        isSecondaryTheme,
        albumPin: albumPin.trim() || null,
      };

      // Send JSON payload
      const response = await axios.post(API_CREATE_EVENT_URL, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.data.success) {
        setSuccessMessage("¡El evento se ha creado con éxito!");

        // Generate and set the event URL
        const generatedUrl = `https://snap-moments.com/album?eventId=${eventId}`;
        setEventUrl(generatedUrl);
        setCreatedEventData({ albumOf, eventDate, eventUrl: generatedUrl, eventType });

        // Clear inputs
        setEventId("");
        setCoverImageUrl("");
        setCoverImageFile(null);
        setCustomMessage("");
        setAlbumOf("");
        setAlbumCreatedBy("");
        setEventDate("");
        setSecret(""); // Clear secret input
        setHasVideo(false);
        setHasGuestBook(false);
      } else {
        setErrorMessage("Hubo un error al crear el evento.");
      }
    } catch (error) {
      console.error("Error creating event:", error);
      setErrorMessage(`${error.response.data.error}`);
      // setErrorMessage(`Error: ${error.message}`);
    } finally {
      setIsCreating(false);
    }
  };

  const handleFileUpload = async (event) => {
    event.preventDefault();
    setErrorMessageFileUpload("");
    setSuccessMessageFileUpload("");

    if (!coverImageFile) {
      setErrorMessageFileUpload("Por favor, selecciona un archivo para subir.");
      return;
    }

    try {
      // Step 1: Get the signed URL from the Cloud Function
      const response = await axios.post(
        "https://us-central1-moonlit-sphinx-400613.cloudfunctions.net/add-cover-photo-album",
        {
          filename: coverImageFile.name,
          contentType: coverImageFile.type,
        }
      );

      if (response.status !== 200) {
        throw new Error("Failed to get signed URL");
      }

      const { uploadUrl, publicUrl } = response.data;

      // Log the upload URL and public URL for debugging
      console.log("Received upload URL:", uploadUrl);
      console.log("Public URL:", publicUrl);

      // Step 2: Upload the file using the signed URL
      const uploadResponse = await axios.put(uploadUrl, coverImageFile, {
        headers: {
          "Content-Type": coverImageFile.type, // Make sure the content type matches the file type
        },
      });

      if (uploadResponse.status === 200) {
        console.log("File uploaded successfully!");

        // Step 3: Update the UI with the public URL
        setUploadedImageUrl(publicUrl);
        setSuccessMessageFileUpload("La imagen se subió correctamente.");
        setCoverImageFile(null);
      } else {
        throw new Error("Failed to upload image to Cloud Storage");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      setErrorMessageFileUpload("Error al subir la imagen.");
    }
  };

  return (
    <div className="create-event-container">
      <Link to="/">
        <Header />
      </Link>
      <h2>Crear Nuevo Evento</h2>

      <form onSubmit={handleCreateEvent}>
        <label>Álbum de:</label>
        <input
          type="text"
          value={albumOf}
          onChange={(e) => {
            const name = e.target.value;
            setAlbumOf(name);
            const slug = name
              .toLowerCase()
              .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
              .replace(/[^a-z0-9\s-]/g, "")
              .trim()
              .replace(/\s+/g, "-");
            if (slug) {
              const dateSuffix = eventDate ? eventDate.slice(8, 10) + eventDate.slice(5, 7) : "";
              setEventId(dateSuffix ? `${slug}-${dateSuffix}` : slug);
            }
          }}
          placeholder="Ej: Boda Juan y Kari"
          required
        />
        <label>Tipo de evento:</label>
        <select
          value={eventType}
          onChange={(e) => setEventType(e.target.value)}
          style={{ display: "block", width: "100%", padding: "11px 14px", margin: "4px 0 0", border: "1px solid #E0DDD8", borderRadius: "8px", fontSize: "15px", fontFamily: "Inter, sans-serif", color: "#555", background: "#FAFAF8" }}
        >
          <option value="wedding">Casamiento</option>
          <option value="xv">XV Años</option>
          <option value="corporate">Corporativo</option>
          <option value="party">Fiesta / Cumpleaños</option>
        </select>
        <label>Fecha del Evento:</label>
        <input
          type="date"
          value={eventDate}
          onChange={(e) => {
            const date = e.target.value;
            setEventDate(date);
            if (albumOf) {
              const slug = albumOf
                .toLowerCase()
                .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
                .replace(/[^a-z0-9\s-]/g, "")
                .trim()
                .replace(/\s+/g, "-");
              const dateSuffix = date ? date.slice(8, 10) + date.slice(5, 7) : "";
              setEventId(dateSuffix ? `${slug}-${dateSuffix}` : slug);
            }
          }}
          required
        />
        <label>ID del evento (auto-generado, podés editarlo):</label>
        <input
          type="text"
          value={eventId}
          onChange={(e) => setEventId(e.target.value)}
          placeholder="Se genera automáticamente"
          required
          style={{ fontSize: "13px", color: "#999" }}
        />
        <label>Álbum creado por:</label>
        <input
          type="text"
          value={albumCreatedBy}
          onChange={(e) => setAlbumCreatedBy(e.target.value)}
          placeholder="Nombre del creador del álbum"
          required
        />
        <label>Imagen de portada:</label>
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setCoverImageFile(e.target.files[0])}
        />
        {coverImageFile && (
          <p style={{ fontSize: "13px", color: "#999", margin: "4px 0" }}>
            Archivo seleccionado: {coverImageFile.name}
          </p>
        )}
        {coverImageUrl && !coverImageFile && (
          <p style={{ fontSize: "13px", color: "#999", margin: "4px 0" }}>
            URL actual: {coverImageUrl.substring(0, 60)}...
          </p>
        )}
        <input
          type="text"
          value={coverImageUrl}
          onChange={(e) => setCoverImageUrl(e.target.value)}
          placeholder="O pegá una URL directamente"
        />
        {/* <label>¿El evento tiene video?</label>
        <div className="radio-group">
          <label>
            <input
              type="radio"
              value={true}
              checked={hasVideo === true}
              onChange={() => setHasVideo(true)}
            />
            Sí
          </label>
          <label>
            <input
              type="radio"
              value={false}
              checked={hasVideo === false}
              onChange={() => setHasVideo(false)}
            />
            No
          </label>
        </div> */}
        <label>Guestbook digital:</label>
        <div className="radio-group">
          <label>
            <input type="radio" value={true} checked={hasGuestBook === true} onChange={() => setHasGuestBook(true)} />
            Sí
          </label>
          <label>
            <input type="radio" value={false} checked={hasGuestBook === false} onChange={() => setHasGuestBook(false)} />
            No
          </label>
        </div>
        <label>Portal fotógrafo:</label>
        <div className="radio-group">
          <label>
            <input type="radio" value={true} checked={hasPhotographer === true} onChange={() => setHasPhotographer(true)} />
            Sí
          </label>
          <label>
            <input type="radio" value={false} checked={hasPhotographer === false} onChange={() => setHasPhotographer(false)} />
            No
          </label>
        </div>
        <label>PIN de acceso (opcional — deja vacío para álbum público):</label>
        <input
          type="text"
          value={albumPin}
          onChange={(e) => setAlbumPin(e.target.value)}
          placeholder="Ej: 1234"
          maxLength={10}
        />
        <label>Token de autorización:</label>
        <input
          type="text"
          value={secret}
          onChange={(e) => setSecret(e.target.value)}
          placeholder="Secret Key"
          required
        />
        <button type="submit" disabled={isCreating}>
          {isCreating ? "Creando..." : "Crear Evento"}
        </button>
        {isCreating && <p>Creando el evento, por favor espera...</p>}
        {errorMessage && <p className="error-message">{errorMessage}</p>}
        {successMessage && <p className="success-message">{successMessage}</p>}



        {/* Display the event URL after creation */}
        {eventUrl && (
          <div className="event-url">
            <p>
              El evento ha sido creado exitosamente. Accedé al álbum en el
              siguiente enlace:
            </p>
            <a href={eventUrl} target="_blank" rel="noopener noreferrer">
              {eventUrl}
            </a>



            {/* Generate and display the QR code for the event URL */}
            <div className="qr-code">
              <h2>QR Code para el evento:</h2>
              <div className="qr-code__wrapper">
                <QRCodeCanvas value={eventUrl} size={150} />
                <i
                  className="fas fa-download qr-code__download"
                  onClick={downloadQRCode}
                  title="Descargar QR"
                />
              </div>
              <div style={{ display: "none" }} ref={hiddenCanvasRef}>
                <QRCodeCanvas value={eventUrl} size={1000} />
              </div>
              <input
                type="text"
                value={eventUrl}
                readOnly
                style={{ fontSize: "13px", color: "#999", textAlign: "center", marginTop: "12px" }}
              />
              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  navigator.clipboard.writeText(eventUrl);
                }}
                style={{ marginTop: "6px", fontSize: "13px" }}
              >
                Copiar URL
              </button>
            </div>
          </div>
        )}
      </form>

      {/* Design generator disabled — pending Canva API integration
      {createdEventData && (
        <DesignGenerator
          eventUrl={createdEventData.eventUrl}
          albumOf={createdEventData.albumOf}
          eventDate={createdEventData.eventDate}
          eventType={createdEventData.eventType}
        />
      )}
      */}

      <footer className="support-footer">
        <p>
          Si experimentás algún inconveniente durante la creación del evento,
          escribinos a{" "}
          <a href="mailto:contacto@snap-moments.com">
            contacto@snap-moments.com
          </a>
          .
        </p>
      </footer>
    </div>
  );
};

export default CreateEvent;